<template>
    <div
        v-if="shouldShowOfflineNotification"
        class="offline-notification"
    >
        <div class="offline-notification-header">
            <p class="offline-notification-text">Looking for Connection...</p>
            <LoaderIconSmall class="offline-notification-loader"/>
        </div>
        <div
            v-if="hasStoredActions"
            class="offline-notification-content"
        >
            <p>{{ offlineAlertTransactionText }}</p>
            <p>GO ONLINE</p>
        </div>
    </div>
</template>

<script>
// IDB
import MailServices from '@/idb/MailServices';

// Components
import LoaderIconSmall from '@/components/base/LoaderIconSmall';

export default {
    name: 'TheOfflineNotification',
    components: {
        LoaderIconSmall,
    },
    props: {
        isOnline: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            // https://renatello.com/vue-js-polling-using-setinterval/
            pollingFunctionRef: null,
            storedActionList: [],
        };
    },
    computed: {
        /** @returns { Number } */
        storedActionListCount() {
            return this.storedActionList.length;
        },
        /** @returns { Boolean } */
        hasStoredActions() {
            return this.storedActionListCount > 0;
        },
        /** @returns { String } */
        offlineAlertTransactionText() {
            // X transaction(s) pending - go online
            const transactionText = `TRANSACTION${ this.storedActionListCount === 1 ? '' : 'S' }`;
            return `${ this.storedActionListCount } ${ transactionText } PENDING`;
        },
        /** @returns { Boolean } */
        shouldShowOfflineNotification() {
            return !this.isOnline || this.hasStoredActions;
        },
    },
    watch: {
        isOnline() {
            if ( !this.isOnline ) {
                this.pollStoredActions();
            } else if ( this.storedActionList.length === 0 ) {
                // Clear the interval handler when there are no more stored actions
                // 10 out of 10 doctors recommend this to prevent memory leaks
                clearInterval( this.pollingFunctionRef );
            }
        },
    },
    methods: {
        async getStoredActions() {
            this.storedActionList = await MailServices.getAllActions();
        },
        pollStoredActions() {
            this.pollingFunctionRef = setInterval( () => {
                this.getStoredActions();
            }, 1000 ); // Will 1 second be too quick when we have a lot of actions? Should we see how long this takes with code?
        },
    },
};
</script>

<style scoped lang="scss">
.offline-notification {
    color: white;
    display: flex;
    flex-flow: column nowrap;
}

.offline-notification-header {
    height: 2.5rem;
    display: flex;
    flex-flow: row nowrap;

    >* {
        margin-top: auto;
        margin-bottom: auto;
    }
    .offline-notification-text {
        padding-top: 0.25rem;
        margin-left: auto;
    }
    .offline-notification-loader {
        margin-right: auto;
    }
}

.offline-notification-content {
    font-weight: bolder;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
}

/* media queries */
@include mixins-above(tablet){
    //
}

@include mixins-above(desktop){
    .offline-notification-content {
        flex-flow: column nowrap;
        // Center text horizontally
        >* {
            margin: 0 auto 0 auto;
        }
    }
}
</style>
